import swiper from 'swiper';

$(document).ready(() => {

  var $slider = $('.js-heroSlider')

  if ($slider.length === 0) {
    return;
  }

  var heroSlider = new Swiper($slider, {
    effect: 'fade',
    simulateTouch: false,
    autoplay: 5000,
    autoplayDisableOnInteraction: false,
  });

});



// WEBPACK FOOTER //
// ./wp-content/themes/figpress-child/src/js/modules/_hero-slider.js